import Domain from 'enums/Domain'
import { setMarkers } from 'utils/rtlTextUtil'
import { replaceMentionedUrls } from 'utils/richMentionedUrlsUtil'
import { getTwitterComplianceText } from 'utils/twitterComplianceUtil'
import { replaceEmojiWithTwEmoji } from 'utils/emojiUtil'
import { Metadata } from '../../adaptor/metadata'
import originalAuthorResolver from '../originalAuthor/originalAuthorResolver'
import domainResolver from '../document/domainResolver'
import displayTextRangeResolver from './displayTextRangeResolver'
import mentionedUrlsResolver from '../mentionedUrl/mentionedUrlsResolver'
import postTypeResolver from '../document/postTypeResolver'
import { removeMetaData } from './retweetsUtil'

export const decorateDisplayText = (text: string, metadata: Metadata, isHighlighted?: boolean) => {
  if (!text) {
    return text
  }

  const { originalAuthor } = originalAuthorResolver(metadata)
  const { postType } = postTypeResolver(metadata)
  let displayText = removeMetaData(text, originalAuthor!, postType!)
  displayText = setMarkers(displayText)!

  const { domain } = domainResolver(metadata)
  const { displayTextRange } = displayTextRangeResolver(metadata)
  const { mentionedUrls } = mentionedUrlsResolver(metadata)
  switch (domain) {
    case Domain.TWITTER:
      if (displayTextRange && displayTextRange[0] && displayTextRange[0].startOffset! > 0) {
        displayText = displayText.substring(displayTextRange[0].startOffset!)
      }

      if (isHighlighted) {
        displayText = replaceMentionedUrls(displayText, mentionedUrls!)
      } else {
        displayText = getTwitterComplianceText(displayText, mentionedUrls!)
      }
      break
    default:
      break
  }

  if (displayText) {
    displayText = replaceEmojiWithTwEmoji(displayText)
  }

  return displayText
}

export const decorateHighlightedDisplayText = (text: string, metadata: Metadata) =>
  decorateDisplayText(text, metadata, true)
